import { useSelector } from 'react-redux';

import { useQueryParams, useRouter } from '@main/core-ui';

import { selectActiveDataSubject } from '../containers/ActiveDataSubject/selectors';
import { useAuthorizationUrl } from '../containers/Login/generateAuthorizationUrl';
import { writeOauthStateToLocalStorage } from '../containers/TokenLogin/helpers';

/**
 * Redirects to a new OAuth/Token URL or to the current location with new query parameters
 *
 * If OAuth URL/Token url is available, it writes the OAuth state to local storage and redirects.
 * Otherwise, it redirects to the current location with new query parameters.
 *
 * @returns The login function
 */
export function useLoginRedirection(): (
  whenQuery: {
    /** The key of the query parameter to check */
    key: string;
    /** The value of the query parameter to check */
    value: string;
  },
  search: string,
) => void {
  const { location, redirect } = useRouter();
  const queryParams = useQueryParams();
  const activeDataSubject = useSelector(selectActiveDataSubject);
  const authorizationUrlPayload = useAuthorizationUrl(
    activeDataSubject,
    location.pathname,
  );

  return (whenQuery, search) => {
    if (queryParams[whenQuery.key] === whenQuery.value) {
      if (authorizationUrlPayload) {
        writeOauthStateToLocalStorage(authorizationUrlPayload.state);
        window.location.replace(authorizationUrlPayload.url.href);
      } else {
        redirect({ ...location, search });
      }
    }
  };
}
